import { Box, CircularProgress, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as LeftArrowIcon } from "../../../../../assets/svg/LeftArrowIcon.svg";
import { milestoneStatusStyleArray } from "../../../config";
import { formattedAmount } from "../../../../../utils/CommonFunction";
import moment from "moment";
import BudgetCarousel from "./BudgetCarousel";
import styles from "./styles";
import { Setting } from "../../../../../utils/Setting";
import { postFormData } from "../../../../../utils/APIHelper";
import { toast } from "react-toastify";
import { getApiData } from "../../../../../utils/APIHelper";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import { isArray, isEmpty } from "lodash";

export const getStatusDisplayText = (text) => {
  if (typeof text !== "string") return text;
  const displayText = text
    .replace(/[-_]/g, " ")
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return displayText;
};

function ProposalMilestoneDetails() {
  const { id, milestoneId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const { milestoneData, project } = location.state || {};
  const [loader, setLoader] = useState(true);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [details, setDetails] = useState([]);
  const [milestoneDetails, setMilestoneDetails] = useState({});
  const [selectedBudget, setSelectedBudget] = useState(null);

  useEffect(() => {
    if (milestoneData && project) {
      setMilestoneDetails(milestoneData);
      setLoader(false);
    }
  }, [milestoneData, project]);

  async function getDetailsApiCall(id) {
    setLoader(true);
    try {
      const response = await getApiData(
        `${Setting.endpoints.getProject}?proposal_id=${id}`,
        "GET",
        {}
      );
      if (
        response.success &&
        isArray(response?.data) &&
        !isEmpty(response?.data)
      ) {
        const data = response?.data[0];
        setDetails(data);
        const newMilestoneData = data?.milestone?.find(
          (m) => m.id === Number(milestoneId)
        );
        setMilestoneDetails(newMilestoneData);

        if (selectedBudget !== null) {
          const newMilestoneData = data?.milestone?.find(
            (m) => m.id === Number(selectedBudget?.milestone_id)
          );

          if (newMilestoneData) {
            const matchedBudget = newMilestoneData.budget.find(
              (b) => b.id === selectedBudget.id
            );
            if (matchedBudget) {
              setSelectedBudget(matchedBudget);
            }
          }
        }
      }
      setLoader(false);
    } catch (error) {
      console.log("error:===>>>", error);
      setLoader(false);
    }
  }

  const handleImageChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("file_1", file);
      formData.append("type", "milestone");
      formData.append("tags", "Milestone_Image");
      formData.append("project_id", milestoneDetails?.id);

      try {
        const response = await postFormData(
          Setting.endpoints.projectFiles,
          formData
        );
        if (response.success) {
          toast.success("File uploaded successfully");
          await getDetailsApiCall(id);
        } else {
          toast.error("File upload failed");
        }
      } catch (error) {
        toast.error("An error occurred during file upload");
      }
    }
  };

  const handleDeleteImage = async (index) => {
    setButtonLoader(true);
    try {
      const response = await getApiData(
        `api/project/delete-files/${milestoneDetails.milestone_image.id}`,
        "POST",
        {},
        { "Content-Type": "application/json" },
        false
      );
      if (response.success) {
        toast.success(response.message);
        await getDetailsApiCall(id);
      }
    } catch (error) {
      toast.error(error.toString());
    } finally {
      setButtonLoader(false);
    }
  };

  return loader ? (
    <center style={styles.header}>
      <CircularProgress />
    </center>
  ) : (
    <>
      <div style={styles.container}>
        <header style={styles.header}>
          <div style={styles.headerContent}>
            <LeftArrowIcon
              onClick={() => navigate(-1)}
              style={{ cursor: "pointer" }}
            />
            <div
              style={{ ...styles.idText, fontSize: "14px", fontWeight: "500" }}
            >
              {project?.name}
            </div>
          </div>
        </header>

        <div style={styles.subContainer}>
          <div style={{ display: "flex" }}>
            <div style={{ ...styles.rowFlex, gap: "15px", flex: "1" }}>
              {milestoneDetails?.milestone_image ? (
                <div style={{ position: "relative" }}>
                  <img
                    src={milestoneDetails?.milestone_image?.path}
                    alt="Miletsone Image"
                    style={{
                      width: "100px",
                      height: "100px",
                      border: "2px solid #ddd",
                      borderRadius: "8px",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    }}
                  />
                  <IconButton
                    onClick={() => handleDeleteImage()}
                    style={{
                      position: "absolute",
                      top: "-6px",
                      right: "-6px",
                      padding: "4px",
                      backgroundColor: "#fafafa",
                      borderRadius: "50%",
                      border: "1px solid red",
                    }}
                  >
                    <CloseIcon style={{ fontSize: "12px", color: "red" }} />
                  </IconButton>
                </div>
              ) : (
                <IconButton
                  component="label"
                  style={{
                    width: "100px",
                    height: "100px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "8px",
                    border: "1px dashed #ccc",
                    margin: "0",
                    cursor: "pointer",
                    background: "#fafafa",
                  }}
                  disabled={!!milestoneDetails?.milestone_image}
                >
                  <AddIcon fontSize="small" />
                  <input
                    type="file"
                    hidden
                    onChange={(e) => handleImageChange(e)}
                    accept="image/*"
                  />
                </IconButton>
              )}
              <div style={styles.columnFlex}>
                <h2 style={styles.projectHeading}>
                  {milestoneDetails?.milestone_name}
                </h2>
                <p style={styles.endDate}>
                  Last Update:{" "}
                  {milestoneDetails?.updatedAt
                    ? moment(milestoneDetails.updatedAt).format(
                        "MMM DD, YYYY hh:mm A"
                      )
                    : "N/A"}
                </p>

                <div style={styles.statusContainer}>
                  <div
                    style={{
                      ...styles.milestoneStatusCircle,
                      backgroundColor:
                        milestoneStatusStyleArray.find(
                          (style) => style.status === milestoneDetails?.status
                        )?.backgroundColor || "#FFAD5C",
                    }}
                  ></div>
                  <div style={styles.statusText}>
                    {getStatusDisplayText(milestoneDetails?.status)}
                  </div>
                </div>
              </div>
            </div>

            <div style={{ ...styles.columnFlex, flex: "1" }}>
              <p style={styles.idLabel}>Amount</p>
              <p style={styles.price}>
                {console.log(
                  "milestoneDetails?.amount",
                  milestoneDetails?.amount
                )}
                {milestoneDetails?.amount !== null
                  ? formattedAmount(milestoneDetails?.amount)
                  : "-"}
              </p>
            </div>

            <div style={{ ...styles.columnFlex, flex: "1" }}>
              <p style={styles.idLabel}>Contractor</p>
              <div>
                <Box display="flex" alignItems="center">
                  {project?.Contractor && (
                    <Box
                      component="img"
                      src={
                        project?.Contractor?.profile_url ||
                        "https://renohome.blob.core.windows.net/reno-cms/e56d3d53-e335-425f-990e-16e6b2bbee1b"
                      }
                      alt="Project Icon"
                      sx={{
                        width: 35,
                        height: 35,
                        borderRadius: "50%",
                        boxShadow: "0px 4px 2.67px 0px #00000026",
                        marginRight: 1,
                      }}
                    />
                  )}
                  {project?.Contractor?.company_name}
                </Box>
              </div>
            </div>
          </div>
        </div>

        <div style={{ ...styles.overview_section, margin: "1vh 2vw 0 2vw" }}>
          <div style={{ ...styles.section_1, ...styles.columnFlex }}>
            <div style={{ ...styles.columnFlex }}>
              <div style={styles.section_heading}>Description</div>
              <h3 style={styles.section_sub_heading}>
                {milestoneDetails?.description}
              </h3>
            </div>
            <div style={{ ...styles.columnFlex, marginTop: "2vh" }}>
              <BudgetCarousel
                details={milestoneDetails}
                selectedBudget={selectedBudget}
                setSelectedBudget={setSelectedBudget}
                getDetailsApiCall={getDetailsApiCall}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProposalMilestoneDetails;
